export const CONTACT_TYPES = [
  { value: 'PRIMARY', label: 'Primary', color: '#3a3' },
  { value: 'KBIS', label: 'KBIS', color: '#33a' },
  { value: 'MARKETING', label: 'Marketing', color: '#a33' },
  { value: 'HR', label: 'HR', color: '#aa3' },
  { value: 'TRAINING', label: 'Training', color: '#3aa' },
  { value: 'PRESIDENT', label: 'President', color: '#790985' },
  { value: 'CEO', label: 'CEO', color: '#d1850a' },
];



// WEBPACK FOOTER //
// ./src/common/constants.ts